import React, { FunctionComponent, MouseEvent, useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleRight, faBookOpen, faChartArea,
  faClipboardQuestion, faInfoCircle, faTasks,
} from "@fortawesome/free-solid-svg-icons";
import "./Menu.css";

interface MenuProps {
  logo: string;
  link?: string;
}

interface LogoProps {
  logo: string;
}

const Logo: FunctionComponent<LogoProps> = ({ logo }) => {
  const { t } = useTranslation();
  return (
    <div id="logo">
      <img src={logo} alt={t("app.title")} />
    </div>
  );
};

const Menu: FunctionComponent<MenuProps> = ({ logo, link = "" }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleToggleOpen = (event: MouseEvent) => {
    event.preventDefault();

    setOpen(!open);
  };

  const className = classNames({
    open,
  });
  const rotation = open ? 180 : undefined;

  return (
    <div id="menu" className={className}>
      {
        link
          ? (
            <a href={link}>
              <Logo logo={logo} />
            </a>
          )
          : <Logo logo={logo} />
      }
      <nav>
        <NavLink to="/">
          <div className="icon"><FontAwesomeIcon icon={faTasks} size="lg" /></div>
          <div className="text">{t("menu.test")}</div>
        </NavLink>
        <NavLink to="/quizzes">
          <div className="icon"><FontAwesomeIcon icon={faClipboardQuestion} size="lg" /></div>
          <div className="text">{t("menu.quizzes")}</div>
        </NavLink>
        <NavLink to="/rules">
          <div className="icon"><FontAwesomeIcon icon={faBookOpen} size="lg" /></div>
          <div className="text">{t("menu.rules")}</div>
        </NavLink>
        <NavLink to="/stats">
          <div className="icon"><FontAwesomeIcon icon={faChartArea} size="lg" /></div>
          <div className="text">{t("menu.stats")}</div>
        </NavLink>
        <NavLink to="/about">
          <div className="icon"><FontAwesomeIcon icon={faInfoCircle} size="lg" /></div>
          <div className="text">{t("menu.about")}</div>
        </NavLink>
      </nav>
      <div id="menu-spacer" />
      <div id="menu-footer">
        <button type="button" onClick={handleToggleOpen} aria-pressed={open} aria-label={t("app.toggle-menu")}>
          <div className="icon">
            <FontAwesomeIcon icon={faArrowAltCircleRight} size="lg" rotation={rotation} />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Menu;
